import { render } from "./User.vue?vue&type=template&id=55e33a00&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=55e33a00&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-55e33a00"

export default script